// ink-component
import React, { HTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';
import { MOBILE_WIDTH } from '../../../helpers/constants/responsive-breakpoints';

import getGlobalProps from '../../../helpers/constants/global-props';

export interface ModalBodyProps extends HTMLAttributes<HTMLDivElement> {
  /** Content */
  children?: ReactNode;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

const ModalBodyWrapper = styled.div`
  @media (max-width: ${MOBILE_WIDTH}px) {
    flex: 1;
    overflow: auto;
  }
`;

const globalProps = getGlobalProps({});

/**
 * @purpose Container for modal body contents
 * @group Modal
 */
const ModalBody = ({ className, style, children, 'data-testid': dataTestId, ...otherProps }: ModalBodyProps) => {
  return (
    <ModalBodyWrapper {...otherProps} {...globalProps} data-testid={dataTestId}>
      {children}
    </ModalBodyWrapper>
  );
};

ModalBody.displayName = 'Modal.Body';

export default ModalBody;
